import moment from 'moment'

// Calculate days old
export function daysOld(d) {
    var today = new Date();
    var from = new Date(d);
    var timeinmilisec = today.getTime() - from.getTime();
    var result = Math.ceil(timeinmilisec / (1000 * 60 * 60 * 24));
    return (result > 0 ? result : 0);
}

export function daysOldIcon(d) {
    var value = '';
    var days = daysOld(d);

    if (days > 365 || d === '') {
        value = '<i class="icon-exclamation text-danger"></i>';
    } else if (days >= 335) {
        value = '<i class="icon-clock text-warning"></i>';
    } else {
        value = '<i class="icon-check text-success"></i>';
    }

    return value;
}

// Calulate days until due (dueInDays defaults to 365)
export function daysUntilDue(d, dueInDays) {
    var days = daysOld(d);
    if (!dueInDays) dueInDays = 365;

    var dueIn = dueInDays - days;
    if (!d || d.length < 1) dueIn = 0;

    return dueIn;
}

// Calculate days until date
export function daysUntil(d) {
    var today = new Date();
    var target = new Date(d);
    var timeinmilisec = target.getTime() - today.getTime();
    var result = Math.ceil(timeinmilisec / (1000 * 60 * 60 * 24));
    return (result > 0 ? result : 0);
}

// Format a date string
export function formatDate(d, format) {
    if (!format) format = 'YYYY-MM-DD HH:mm';
    return d ? moment(String(d)).format(format) : '';
}